var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userType === 'super')?_c('SelectBox',{attrs:{"selectStyleWidth":_vm.selectStyleWidth,"value":_vm.select,"items":_vm.list},on:{"changeSelect":_vm.updateSelect}}):_c('span',{staticClass:"clinicOne"})}
var staticRenderFns = []

export { render, staticRenderFns }